import { DestroyRef, Directive, HostListener, inject, Input } from '@angular/core';
import { AutocompleteService } from '@shared/services/autocomplete.service';
import { BehaviorSubject } from 'rxjs';
import { DatepickerService } from '@shared/services/datepicker.service';
import { debounceTime } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Directive({
 selector: '[ihoAutocomplete]',
 standalone: true,
})
export class AutocompleteDirective {
 constructor() {
  this.userInput
   .pipe(takeUntilDestroyed(this.destroyRef), debounceTime(300))
   .subscribe((searchQuery) => this.autocompleteService.fetchHotelInfoSuggest(searchQuery));
 }

 autocompleteService = inject(AutocompleteService);
 datepickerService = inject(DatepickerService);
 destroyRef = inject(DestroyRef);

 @Input() isMobile = false;
 userInput = new BehaviorSubject<string>('');

 convertToPersian(input: string) {
  const letters: Record<string, string> = {
   q: 'ض',
   w: 'ص',
   e: 'ث',
   r: 'ق',
   t: 'ف',
   y: 'غ',
   u: 'ع',
   i: 'ه',
   o: 'خ',
   p: 'ح',
   '[': 'ج',
   ']': 'چ',
   a: 'ش',
   s: 'س',
   d: 'ی',
   f: 'ب',
   g: 'ل',
   h: 'ا',
   j: 'ت',
   k: 'ن',
   l: 'م',
   ';': 'ک',
   "'": 'گ',
   '\\': 'پ',
   z: 'ظ',
   x: 'ط',
   c: 'ز',
   v: 'ر',
   b: 'ذ',
   n: 'د',
   m: 'پ',
   ',': 'و',
   C: 'ژ',
   H: 'آ',
   A: 'ؤ',
   S: 'ئ',
   G: 'أ',
   L: '«',
   K: '»',
  };
  let output = '';
  for (let i = 0, inputLenght = input.length; i < inputLenght; i++) {
   output += letters[input.charAt(i)] || input.charAt(i);
  }
  return output;
 }

 @HostListener('click', ['$event']) onClick() {
  this.autocompleteService.adCode.set(false);
  if (this.isMobile) {
   this.autocompleteService.setIsMobile(true);
   this.datepickerService.setIsMobile(true);
  }
  this.autocompleteService.setState('favorite');
 }

 autocompleteValue = '';
 @HostListener('keyup', ['$event']) onInput(event: { target: { value: string } }) {
  this.autocompleteValue = this.convertToPersian(event.target.value);
  this.autocompleteService.setState('loading');
  this.userInput.next(this.autocompleteValue);
 }
}
